module.exports = "/images/claim_organization.jpg?f697a64ce14db1c88c740983dfe44b65";